export default "<carousel-item data-@class=\"@[class]\" data-@style=\"background-image:url('@{}')\"></carousel-item>";